module.exports = __webpack_public_path__ + "static/media/toggle.81bc1634.svg";